/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n={stableRendering:!1},e={rootOrigin:null};export{e as gridLocalOriginFactory,n as textTextureAtlas};
